import React, { memo } from 'react';
import { Modal, Backdrop, Fade, Paper, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import useModalAddMessage from './useModalAddMessage';
import Loading from '../../loading';
import ButtonCustom from '../../buttonCustom';
import AlertCustom from '../../alertCustom';
import InputSelect from '../../form/inputSelect';

import {
    Title,
    TitleIcon,
    Transition,
    FormPage,
    GroupField,
    LabelField,
    InputDate,
    InputTextArea,
    InputBtnUpload,
    ListPreviewFotos,
    PreviewFoto,
    MessageAnexo,
} from './Styled';

import ComunImg from '../../../screens/addMessage/images/talk.png';

const ModalAddMessage = ({
    showModal,
    setShowModal,
    selectedSessionId,
    mudarStatusSessao,
    handleLinkCommunication,
    setOptions,
    setShowOptions,
    setShowInputBar,
    setMessages,
    LogoImg,
}) => {
    const {
        transitionIn,
        loadingPage,
        loadingForm,
        optionsArea,
        optionsRegional,
        hasSelectMultiple,
        area,
        tipo,
        regional,
        data,
        dataFim,
        cid,
        previewFotos,
        comentario,
        fieldErrors,
        openAlert,
        messageAlert,
        optionsTipo,
        isAtestado,
        setOpenAlert,
        handleChangeArea,
        handleChangeTipo,
        handleRemoveItemSelect,
        handleChangeRegional,
        handleChangeData,
        handleChangeDataFim,
        handleChangeCid,
        handleChangeFotos,
        handleRemoveFoto,
        handleChangeComentario,
        handleSubmit,
        translate,
        handleClose,
    } = useModalAddMessage({
        selectedSessionId,
        mudarStatusSessao,
        handleLinkCommunication,
        onClose: () => setShowModal(false),
        setOptions,
        setShowOptions,
        setShowInputBar,
        setMessages,
        LogoImg,
    });

    return (
        <Modal
            open={showModal}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={showModal}>
                <Paper
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '95%', sm: '90%', md: '80%', lg: '60%' },
                        maxHeight: '90vh',
                        overflow: 'auto',
                        p: 4,
                        boxShadow: 24,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                    }}
                >
                    <Box display="flex" justifyContent="flex-end">
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {loadingPage ? (
                        <Loading />
                    ) : (
                        <>
                            <Title transition={transitionIn}>
                                <TitleIcon src={ComunImg} />
                                {translate('addMessage.title')}
                            </Title>

                            <Transition transitionIn={transitionIn}>
                                <FormPage
                                    transition={transitionIn}
                                    encType="multipart/form-data"
                                    method="post"
                                    autoComplete="off"
                                    loadingForm={loadingForm}
                                    onSubmit={handleSubmit}
                                >
                                    <GroupField>
                                        <InputSelect
                                            transparent="false"
                                            name="area"
                                            id="area"
                                            labeldark="true"
                                            label={translate('addMessage.selectArea')}
                                            value={area}
                                            onChange={handleChangeArea}
                                            options={optionsArea}
                                            error={
                                                fieldErrors.find((inp) => inp.name === 'area' && inp.error === true)
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </GroupField>
                                    <GroupField>
                                        <InputSelect
                                            transparent="false"
                                            multiple={hasSelectMultiple}
                                            name="tipo"
                                            id="tipo"
                                            labeldark="true"
                                            label={translate('addMessage.selectTipo')}
                                            value={tipo}
                                            onRemoveItemSelectMultiple={handleRemoveItemSelect}
                                            onChange={handleChangeTipo}
                                            options={optionsTipo}
                                            error={
                                                fieldErrors.find((inp) => inp.name === 'tipo' && inp.error === true)
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </GroupField>
                                    <GroupField>
                                        <InputSelect
                                            transparent="false"
                                            name="regional"
                                            id="regional"
                                            labeldark="true"
                                            label={translate('addMessage.selectRegional')}
                                            value={regional}
                                            onChange={handleChangeRegional}
                                            options={optionsRegional}
                                            error={
                                                fieldErrors.find((inp) => inp.name === 'regional' && inp.error === true)
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </GroupField>
                                    <GroupField>
                                        <LabelField>{translate('addMessage.labelDataRef')}</LabelField>
                                        <InputDate
                                            fullWidth
                                            type="date"
                                            id="data"
                                            name="data"
                                            autoComplete="off"
                                            value={data}
                                            onChange={handleChangeData}
                                            error={
                                                fieldErrors.find((inp) => inp.name === 'data' && inp.error === true)
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </GroupField>
                                    {isAtestado && (
                                        <>
                                            <GroupField>
                                                <LabelField>{translate('addMessage.labelDataFim')}</LabelField>
                                                <InputDate
                                                    fullWidth
                                                    type="date"
                                                    id="dataFim"
                                                    name="dataFim"
                                                    autoComplete="off"
                                                    value={dataFim}
                                                    onChange={handleChangeDataFim}
                                                    error={
                                                        fieldErrors.find(
                                                            (inp) => inp.name === 'dataFim' && inp.error === true,
                                                        )
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            </GroupField>

                                            <GroupField>
                                                <LabelField>{translate('addMessage.labelCid')}</LabelField>
                                                <InputDate
                                                    fullWidth
                                                    type="text"
                                                    id="cid"
                                                    name="cid"
                                                    autoComplete="off"
                                                    value={cid}
                                                    onChange={handleChangeCid}
                                                    error={
                                                        fieldErrors.find(
                                                            (inp) => inp.name === 'cid' && inp.error === true,
                                                        )
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            </GroupField>
                                        </>
                                    )}

                                    <GroupField>
                                        <InputTextArea
                                            fullWidth
                                            multiline
                                            minRows={6}
                                            maxRows={10}
                                            id="comentario"
                                            name="comentario"
                                            label={translate('addMessage.textareaComentario')}
                                            autoComplete="off"
                                            value={comentario}
                                            onChange={handleChangeComentario}
                                            error={
                                                fieldErrors.find(
                                                    (inp) => inp.name === 'comentario' && inp.error === true,
                                                )
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </GroupField>
                                    <GroupField flex button>
                                        {previewFotos.length > 0 && (
                                            <ListPreviewFotos>
                                                {previewFotos.map((item, index) => (
                                                    <PreviewFoto
                                                        key={index}
                                                        src={item.img}
                                                        fileName={item.fileName}
                                                        onClick={() => handleRemoveFoto(item)}
                                                    />
                                                ))}
                                            </ListPreviewFotos>
                                        )}

                                        <InputBtnUpload
                                            name="fotos"
                                            label={translate('addMessage.btnAnexo')}
                                            className="btn-anexar"
                                            labelSelect={translate('addMessage.titleSelectFoto')}
                                            onChange={handleChangeFotos}
                                            error={
                                                fieldErrors.find((inp) => inp.name === 'fotos' && inp.error === true)
                                                    ? true
                                                    : false
                                            }
                                        />
                                        <ButtonCustom
                                            color="default"
                                            type="submit"
                                            size="large"
                                            className="btn-green"
                                            fullWidth
                                        >
                                            {translate('addMessage.btnSend')}
                                        </ButtonCustom>
                                        <MessageAnexo id="msg-anexo" />
                                    </GroupField>
                                </FormPage>
                            </Transition>

                            <AlertCustom
                                message={messageAlert}
                                openMessage={openAlert}
                                closeMessage={() => setOpenAlert(false)}
                                transition="down"
                                origin={{ vertical: 'top', horizontal: 'right' }}
                            />
                        </>
                    )}
                </Paper>
            </Fade>
        </Modal>
    );
};

export default memo(ModalAddMessage);
